
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Clear`,
'deleteKey': `⌦ Slett`,
'downKey': `↓ Ned`,
'endKey': `⤓ Slutt`,
'enterKey': `Skriv inn`,
'escapeKey': `⎋ Flukt`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Generer en 
          <code>LICENSE 
          </code> fil 
        `,
'homeKey': `⤒ Hjem`,
'keyCommand': `⌘ Command/Win`,
'keyControl': `^ Kontroll`,
'keyOption': `⌥ Alternativ/Alt`,
'keyShift': `⇧ Skift`,
'leftKey': `← Venstre`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Høyre`,
's00065e45db8c0441': `Se utviklerverktøy for mer informasjon`,
's001dd78415a91fa0': `Rullefeltets rennestein`,
's002fa7d1054ed082': `Ramme`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `kasakhisk`,
's01b56d233c6c5cac': `Seksjonering`,
's01d32b35baa3b676': `Forfatter`,
's02106cc2ef0e7578': `Ny nål...`,
's02ab1ea8e5100fc1': `Merk valget som en "toveis overstyring`,
's0312976fe9da5951': `Knapp`,
's03608a32f05eded2': `Klypezoom`,
's036d35e03be98d22': `Matematisk dybde`,
's037b1dc850a89273': `Alternativ under`,
's0396202b716732ec': `Merk valget som gjennomstrøket`,
's03f49e598ffb11cc': `Polsk`,
's0448f1059fa01720': `Lagre, del eller skriv ut det utforskbare. Rediger informasjon som tittel, språk eller lisens.`,
's0458872c43beadef': `Sett inn rad før`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Avstand mellom ord`,
's05e9759cfd99c48f': `Begrunn`,
's063fa5a0a4903bf4': `Sideveis, fra venstre mot høyre`,
's064339c229374050': `Koding`,
's06634274f19b0572': `Valg av pinner`,
's06743b24499f0035': `Ankersenter`,
's07808b0ca6da8fef': `Inngjerdet nettsted`,
's07970793b21351fd': `Ruby-basisbeholder`,
's079cf7850d9327f0': `Skrifttype`,
's07aa10850d9ddcc7': `Skjema`,
's07e6118e838b2e23': `Navigasjon`,
's0816468df86e4036': `Åpner innstillingene`,
's082869038c117fe5': `Portugisisk (Brasil)`,
's086e6c267ade2609': `Metning`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Lyd`,
's0978fb5ba3145996': `Sett inn en liste (uordnet)`,
's09c3f1d21de14ae1': `Marker valget som understreket`,
's0a2d91c6720033e9': `Trimming av tekstavstand`,
's0a3ddcba94027d95': `Objektets passform`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Sett inn en navigasjon`,
's0a7db790db1fc45c': `Marker markeringen som et spenn`,
's0b1271f50a77dc73': `Innholdsboks`,
's0b24d08ea349b455': `Alt du kan sette inn. Først kommer ikke-interaktive elementer som lister eller bilder, deretter kommer interaktive elementer som kalles widgeter. Du kan hente nye ved å klikke på søkefeltet.`,
's0bdca49248ba4820': `Snarveier`,
's0befccf152b6c0a9': `Orientering fra metadata`,
's0c11e479416c8421': `Sett inn en tabelltittel`,
's0c27336067c59611': `Polstring av rulle`,
's0c4593d81f147042': `Grunnlinje`,
's0c4b2e98d4ab7f5a': `App-kommandoer`,
's0c883713b83616a8': `Lagre det aktive dokumentet`,
's0ca5c0460199cba1': `Forkortelse`,
's0cf10c4f40588f8d': `Bildetekst til tabellen`,
's0d86afa3c6a1e28b': `Flex retning`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Ditt utforskbare dokument. Her kan du skrive tekst og kopiere/lim inn, redigere osv.`,
's0dc452999c129e15': `Aktiver live reload`,
's0de0febab8a4beaf': `Feil ved lesing av denne pakken`,
's0e44968489e076a8': `Kinesisk`,
's0e4862e87c7d53ce': `Merk valget som et sitat`,
's0e6ea8870dbddab2': `Dokumentkommandoer`,
's0ee28503778e4c0c': `Siste baseline`,
's0ef01c03299bbb83': `Dekorasjon`,
's0f17f32919661cff': `Mongolsk`,
's0f350bc4e538e3ea': `Ord`,
's105a06836c40fcb4': `Angi filtre, farge og blanding av valgte elementer`,
's106b274b5af798e5': `Setninger`,
's1082e1649793dca9': `Merk valget som et definert begrep`,
's10f3845975a0351e': `Rediger metadata`,
's1125d159f7e64df5': `Visning`,
's11326fd2590f4e5e': `Standard`,
's1155ec07a221e739': `Rullestolpe`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Synlighet`,
's123bea44f38abccf': `Sett inn objekt`,
's1245e2cb9f20197e': `Juster`,
's12946ec1b850962c': `Sett inn kolonne etter`,
's1351209ef74ee729': `Spenner over alle kolonnene`,
's13c60cb409e8cb6f': `Juster midten`,
's13ebd619c8a06a6d': `Automatiske rader i rutenettet`,
's13ef8ca26ca8861b': `Kuttet element`,
's151bc2eea7a032a4': `-unchanged-`,
's153bc3c3aa39587b': `Bordhode`,
's156647179b21d351': `Sett inn en tabellkropp`,
's158b6ec6b1fffcb2': `Pause etter`,
's15d0c0657c1ee08c': `API-nøkkel`,
's1626a7e10a9f9dcc': `Angir utvalgets skriftfamilie`,
's1637c7d1a30629e2': `Border Box`,
's1641ab440bf4daa4': `Oppdater denne widgetpakken`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Avansert: Vis pakker med versjoner som 0.x.x i pakkebehandleren`,
's16b9446e3a70e1f4': `Egenskaper`,
's16f205466761e583': `Ingen optisk skriftstørrelse`,
's16f2f1c2c516d307': `Åpne et dokument`,
's1749014f3f87fa6a': `Strekk`,
's17597a8bb4810524': `Lisens`,
's17bfaaa4e7528bc7': `Basjkir`,
's17fb3f4805f4f4b9': `Fjern felt`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Opprett pakke`,
's18d5c44aae3dc82a': `Online når du redigerer`,
's1988d71ef8060edf': `Sett inn en tabellrad`,
's19abee1277c9bca2': `Samoansk`,
's19daf2f26c19543d': `Omriss`,
's1a1acc902e6668e0': `Vis avansert tekstformatering`,
's1a5230a71d9285c1': `Fangst`,
's1aa1cb63ad44bc6f': `Spalteåpning`,
's1af8b67d1c85c811': `Mellomrom mellom`,
's1b4a36fce2456660': `Skriftfamilie`,
's1c246045629b0016': `Merk valget som en sletting`,
's1c3fc313a9184670': `Offentlig lenke`,
's1c65f5004a07dcfa': `Skotsk gælisk`,
's1c690963f1e2df00': `Plattformspesifikt utseende`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Vil du ha en kort, guidet omvisning?`,
's1d19244f549ec535': `Utdanning`,
's1d5c7b28e8b50d6d': `Associate Deg.`,
's1db591f5a54dbfd3': `Innholdsboks`,
's1dbb9f50e16c92a3': `Radius på grensen`,
's1dfb744260fb3a01': `Toveis isolat`,
's1e9c2c654732cc5f': `hviterussisk`,
's1eaccbf2d6af8ab5': `Informasjon`,
's1efbfc3937d565bd': `Bakgrunn`,
's1f2b49c1bca2035d': `Katalansk`,
's1f74bdf32b51a5fc': `Bakgrunnsbilde`,
's1f7698c061c208c9': `Åpne`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `korsikansk`,
's21d61916eb8d137d': `Bordkropp`,
's21d723a1dbcd89c8': `javanesisk`,
's21f8a2eaf5a70749': `Sett inn en etikett`,
's2206c42e5b835e6e': `Merk valget som en forkortelse`,
's22a2348c46a912a0': `Sett inn en seksjon`,
's233ae776268cd44b': `Virksomhet`,
's236ed7ba747099b0': `Skriftvekt`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Tekst`,
's24949d7adbb5a098': `Verktøykasse`,
's252a52330d32b900': `Metadata`,
's2540844a4bc4d9ba': `Kreve attribusjon?`,
's255857544a9d5ec0': `Tilbakestill`,
's255c77900f2b5e0f': `Fargevalg`,
's256ab831a48c941c': `Fjerner all tekstformatering fra markeringen`,
's2591806d7b222591': `Tilbakestill endringer`,
's25e1a07e454c2c11': `Rutenett`,
's262abbaf1d05f009': `Mykt lys`,
's266935f2447fcd98': `Over til venstre`,
's268ecd1cef45a9a8': `Er du sikker?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Lysere`,
's27076e66c5d483ba': `Vertikal justering`,
's2712dc5641a33226': `Pakkeregisterkontoer er beregnet for utviklere og lar deg konfigurere ett eller
          flere registre`,
's27cc88818cc46ff6': `Stabil`,
's281d957112b10f12': `Rediger HTML-koden i dokumentet direkte`,
's28b6246ce616a548': `Sett inn en kolonnegruppe i tabellen`,
's29a1c26521879b9f': `Skalere ned`,
's29acfd2778e8c377': `Skjul avansert tekstformatering`,
's29b24c06315e9343': `Sett inn en inngang`,
's29eb103449472e3b': `Sett inn en overskrift (nivå 3)`,
's29ee7434494a0dfe': `Sett inn en overskrift (nivå 2)`,
's29f21c34494d614d': `Sett inn en overskrift (nivå 1)`,
's29fbfc3449557f72': `Sett inn en overskrift (nivå 6)`,
's29ff743449588131': `Sett inn en overskrift (nivå 5)`,
's2a031834495bcdb4': `Sett inn en overskrift (nivå 4)`,
's2a75c946ef4dcab7': `Diverse`,
's2b2ae20d26f78ac2': `Blokk`,
's2b8f50c64be440f7': str`Velg 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Bestilling`,
's2bad2d24def4aa0b': `Linjeskift (CJK-språk)`,
's2ceb11be2290bb1b': `Avbryt`,
's2ced8e8fafb499f6': `Slett element`,
's2d986d31f8d67357': `Sett inn et feltsett`,
's2d995a37cf5e4995': `Sett inn en NoScript`,
's2de969afacdaa7a6': `Form`,
's2df075aface0dab8': `Del`,
's2e192b19ed15fcf6': `Side`,
's2e39b99cf23606fa': `Angi layout for de valgte elementene`,
's2e4818861000b13f': `Layout`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Overløp (y)`,
's2edd6688a65e21f0': `Overløp (x)`,
's2f0bcdffc92a786b': `Flyter til høyre`,
's2f2044f2431a32d5': `Overskrift`,
's2f4d4bfbc466d91f': `Albansk`,
's2f8da2cb5f236588': `Navnet på pakken din. Må være scoped, f.eks. \`@org/pkg\`. `,
's30cce87854901922': `Førskole`,
's3124653c272f054c': `Farge på kolonneregelen`,
's314a4f7685c8e824': `Alltid`,
's31c06e226322f065': `Unngå foreldreløse barn`,
's323dcde72b850272': `Offentlig tilgang`,
's32911e52ee8ac745': `Sett inn et spor`,
's337a1e9022a8d19f': `Tabell`,
's33c1450d2822bb0f': `Sett inn en figurtekst`,
's33c18d5a4cbffa2a': `Irsk`,
's33f85f24c0f5f008': `Spar`,
's342b0cabfa672822': `Hjelp brukeren med å finne widgeten din`,
's3437e0d9899e7ae1': `Send telemetridata om din bruk av WebWriter.`,
's344ea8f4939cdc98': `Farge`,
's34dcda3b0f9d5a98': `Bytt url`,
's34f724979a124c50': `Angir bakgrunnsfargen på den valgte teksten`,
's355b21b89ce5d9c5': `Detaljer`,
's35ae5f4e0fa2777b': `Tilpasset justering`,
's35aeaff1425bca9e': `WebWriter støtter ikke medier av typen `,
's35c3125c7750681e': `Blockquote`,
's3643189d1abbb7f4': `Kode`,
's3649bacefe731bf6': `Veksle verktøykasse`,
's365280e16a8ea32d': `Kopier utvalget`,
's366991b9c9287765': `Høyre`,
's36a194e38d653a26': `Annotering av data`,
's36b3cefdcb897f15': `Perspektiv`,
's372fae706048ce41': `Jevn-odd`,
's377e24af9628c37e': `Bestilt liste`,
's37a8c35f6581da5f': `Ingen anker`,
's37fa3b9cd51c2dfd': `Angir skriftstørrelse for utvalget`,
's380d17664bb69531': `Sett inn kolonne før`,
's3815184eb09f0dcf': `Markør`,
's382a2aa3984474dd': `Opprett`,
's38980f98cb07ceb8': `Lagre det aktive dokumentet som en kopi`,
's3914cb410fca44d4': `Import`,
's3a179f6db2972384': `Ruby-posisjon`,
's3a5ca02f282d247e': `Del...`,
's3ae67088bbefba98': `Pakker`,
's3b0ab4b52326316f': `Lys`,
's3b3ea038c5d3bb06': `Divisjon`,
's3bdad99768e11911': `Utforskbar`,
's3cb47df8290fa94c': `Sett inn et alternativ`,
's3cf89cb47fdde7e9': `Lenke`,
's3d09398e555ee5f9': `Avanserte alternativer`,
's3d249bb480032121': `Liste`,
's3d3efd1e19bdcfb4': `Anmerkning av dato/tid`,
's3d6a732c792ccb9e': `Ruby Annotasjon`,
's3d93f9ea0c5a13fa': `Bilde`,
's3d9548e211b958ce': `Hopp over overlappinger`,
's3e092e9d1ee2c5bb': `Klipp`,
's3e78ddc9a48a608d': `Vakker`,
's3eb6d1e6e79ed7c4': `Ingen dokumenter funnet`,
's3eca5a034978754b': `Slett valget`,
's3f06e9abb6ebcb79': `Karakterer`,
's3f1e7a3f2b283d3b': `Margin`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Sett inn en artikkel`,
's3fd83566dd643d10': `Sett inn en tegnforklaring`,
's3fe72792941c18f9': `Tekst nederst`,
's3ffcdc5db5e7d0c5': `Revers`,
's40e3826b7f74a3b5': `Pan (til høyre)`,
's40f07d7859284a44': `Dominerende grunnlinje`,
's4101ada154a1b958': `Midt`,
's410c465a5993f82d': `Mulighet for linjebrudd`,
's41322d19c928c603': `IKT`,
's417b90913e05bc17': `Forhåndsvisning`,
's418f2020fe996832': `Bekreft endringer`,
's41c724f0698148e9': `Merk valget som en hurtigtast`,
's41f65a763f8e44ab': `Tabellhodegruppe`,
's42721130228841b0': `Slagboks`,
's429bd646f1cf8bc6': `Med Grammar LLM-kontoer kan du bruke Grammar LLM API til å rette grammatikk i tekst.`,
's429dd933ba95549b': `Sett inn en adresse`,
's42e470ef1d707a28': `Autospill`,
's42ffdab1291fb3de': `Sett inn rad etter`,
's430831017f3f0499': `Skråstilling (y)`,
's430bd5017f42511c': `Skråstilling (x)`,
's433ba70286202ceb': `Bryt alle`,
's441b20a8a50e36b4': `makedonsk`,
's445b8acb9206db6e': `Forkast og avbryt`,
's446a924922651ea0': `Vektlegging av tekst`,
's44cdba92713de38e': `Rutenettområde`,
's45518abd911471d0': `Kroatisk`,
's456a8d744313852a': `Plass rundt`,
's4634541f5056a546': `abkhasisk`,
's46d4abe6255cb9e1': `Tilordne snarvei på nytt`,
's4730c232e7209c40': `Trim begge deler`,
's474f0eec369d02a4': `Eksempel på utdata`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Merk markeringen som en dato-/klokkeslettannotasjon`,
's47ebf3a8fb3b10c1': `Orientering`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Alternativ`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Tekstskygge`,
's4993444bfd3f3e5e': `Kollaps`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Maske`,
's49dd67aed00029ef': `Matematikk`,
's49e763aed00877a8': `Viktigste`,
's4a894f57eba1cf1e': `Tastaturgenvei`,
's4ac1ad6ecd6bd810': `Diverse utg.`,
's4ad6e9d3c2365c98': `Hardt lys`,
's4b2c143acf931122': `Linjehøyde`,
's4b58c01e2578f5e4': `Legende`,
's4bbff4e008690da1': `Unngå side`,
's4c1535f316305a2a': `Inspiser utvalget`,
's4c402ff5355fd310': `Toveis overstyring`,
's4caed5b7a7e5d89b': `Engelsk`,
's4cb38675a21b2c98': `Egenskapstypen '\${desc.type}' støttes ikke (behandles som JSON)`,
's4cc8391f172c0cdf': `Avslutt turen`,
's4d528b416ac8dee2': `Sett inn en overskriftsgruppe`,
's4d546f6c87128d5b': `Plass først`,
's4dcb9315f6527f9c': `Kjør ved omlasting`,
's4e191bdb4700a6e9': `Overscroll (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Feil ved tilkobling`,
's4e361bf8eef3759a': `Ordbrudd`,
's4ea0f21fc2a338a1': `Flytt opp`,
's4eace13b3ed74187': `Sidekommentar`,
's4efee5b48a4593cb': `Sløyfe`,
's4f26e7cb7c0a8318': `Vektortegning`,
's4fd2e638aabb0bb3': `WebWriter støtter innbygging av mange forskjellige kilder. Bare lim inn en lenke til
          innhold fra:`,
's4fda04cbc245e18b': `Alfa`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Tynn`,
's50489ffb1bde152e': `Innsetting`,
's5068560b8d39663d': `Klikkbart kart`,
's517acbf1f96324f9': `Vekt`,
's523eb9043213ff0d': `Kursiv`,
's52777d434baeed9b': `Sett inn en fremdriftsindikator`,
's52af5d7ac34c2163': `Tabellrad`,
's52e0bdc3ee304436': `Sett inn en måler`,
's531056f039febd39': `Sett inn en select`,
's536695196d0b6dc3': `Færøysk`,
's542fcefa0bbaed86': `Åpne eller lukk verktøykassen (kun på smale skjermer, ellers er verktøykassen alltid synlig på siden).`,
's5432ad3c84273229': `Figur`,
's543906d1db8b2283': `Rediger `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodsjansk`,
's54897f2764b0e4d0': `Installer denne widgetpakken`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Merk valget som svært viktig`,
's55905c735052d295': `Tematisk pause`,
's5590dbf7e425789d': `Etikett`,
's5623aa2f83b05c76': `tibetansk`,
's564d1648b1ceee9f': `Oppdatert`,
's565cd5ffb0158c46': `Unngå regionen`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Gå tilbake`,
's5787c6d5b3b5541a': `Klippebane`,
's579c69f419b6caef': `Glatt`,
's587ac858dd80f6fa': `Subskript`,
's58bec0ecd4f3ccd4': `Strenge`,
's59404f5593c32fdc': `Skriftsnitt`,
's5941292bb77281ab': `Norsk bokmål`,
's599dcd2472c75c19': `Paragraf`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Merk utvalget med en dataanmerkning`,
's5a356677b61a6b7e': `moldavisk`,
's5b474b5c0ac0c7c4': `Tabellkolonnegruppe`,
's5b517ac216f9ee62': `Sideveis`,
's5b8cc9bb61ddce15': `Sett inn et avsnitt`,
's5bba2ac2e53bd1fd': `Kirgisisk`,
's5be80ad6b8301710': `Inline-start`,
's5c1ecf88259b79f9': `Presentasjon`,
's5c2a1a52c0389c30': `Ingeniørarbeid`,
's5c63af7695445fcf': `Tekststil`,
's5d18ca4c3111be6f': `Sett inn et tabellhode`,
's5d87c1e588f48d90': `Praksis`,
's5d929ff1619ac0c9': `Søk`,
's5da52af9b083c29a': `Modell`,
's5dc77784260a7236': `bil`,
's5e27738a2e8eb763': `Logg inn`,
's5e2cba97c0d971bd': `Last inn pakker på nytt`,
's5e53415a6d5719ad': `Samfunnsvitenskap`,
's5e6a7a0c30d2a270': `Hopp over overlappinger (automatisk)`,
's5e9e8e4d21bafedc': `Matproduksjon`,
's5ed03bb1f3a15949': `Bilde`,
's5f43af3669b1e098': `Kilde`,
's5feaf7fd7ee567c8': `Bryt ord`,
's600fd23c9ce971e8': `Skriv ut det aktive dokumentet`,
's602bbd28dae2c60f': `Selvstart`,
's60ff598dfcf2c773': `Under høyre`,
's61053f0e3ebbd272': `normal`,
's613c6ff83883c04f': `Tabellkolonne`,
's6196153c4b0c1ea0': `Installere`,
's61c017f6d5c303af': `frisisk`,
's61ded17ca3f48c82': `Forskyvning av understreking`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Kopier valg`,
's624e31cd4f1b89d4': `Jevn rulling`,
's626daf42b1ab7df7': `Juster til venstre`,
's6280bf993915c57a': `Rullemargin`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Beskrivelse`,
's63dfc5b1c1c27849': `Jiddisch`,
's63e03c70f67ebf9c': `Sammenheng`,
's63e71d20d1eaca93': `Tysk`,
's640bc7710d0143ce': `Gjør om den siste ugjorte endringen i det aktive dokumentet`,
's64dc1fc7e3db45c9': `Opprett et nytt dokument`,
's65ac276544ba33cd': `SVG-fil`,
's66765c420ee578e4': `Jevnt mellomrom`,
's669b18c6d2d9c95b': `Ingen`,
's6747dbf4ad6063ba': `Egen ende`,
's6787497df07fa97e': `Kan bla over stoppesteder`,
's67c2b60a506a09e4': `Sekundærutdannelse.`,
's680bd4d926cd5a84': `Bevar 3D`,
's6827930ef1aeaf99': `Base URL`,
's684a16f3c711394d': `Over høyre`,
's687e27f036a71b32': `Isolere`,
's68b87d7b61052dc3': `Tabellrad`,
's68e0e3a2bab7ce3e': `Unngå`,
's690da6b432987c6f': `Sikkerhetskopierer endringer i det gjeldende dokumentet automatisk. Endringene gjenopprettes når WebWriter lastes inn på nytt.`,
's69311c4e25074fb3': `Videregående skole`,
's697400b541fbc3cd': `Under`,
's6988ab5d47593a26': `Du har den nyeste versjonen av WebWriter.`,
's69a49786a8009f43': `Finn pakker...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Omslag`,
's69fbbdb8ad2a084a': `Mørkere`,
's6a31eff1ec4f71ad': `Skjul ansiktet bak (3D)`,
's6ac62e1c8c66f3bb': `Kompakt superscr.`,
's6b585ba37cdb8260': `Arve`,
's6b61f8abf89586be': `Hebraisk`,
's6bd7a02fdf93e653': `Juster innholdet`,
's6cfc66b824ea05ba': `Skarpe kanter`,
's6d02dc19e21eb49c': `Topp`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `vietnamesisk`,
's6d8b3b8047ed378d': `Bland blandingsmodus`,
's6d8c02aee480af7a': `Meny`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Sett inn en stil`,
's6e288a119281f4c2': `Gjengivelse av tekst`,
's6e4c20c6debcd5ca': `Tilpasset begrunnelse`,
's6f84199e62584905': `Forhåndsformatert tekst`,
's6fb3053e7244d326': `Andre felt`,
's70178e04a3b691b6': `Åpne innstillinger`,
's7031ca562378bde6': `Geometrisk presisjon`,
's7060970b5ed20a58': `Interaktivitet`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Vis ustabile pakker`,
's71dec51005acc1e4': `Tett rad`,
's72f2a02e2a5a4ee3': `Medier`,
's730182ad28374cda': `Objekt`,
's731678e227a20559': `Denne enheten`,
's736904f276fbd441': `Naturvitenskap`,
's739544d0c858c633': str`Eller slipp 
          ${0} her 
        `,
's73cb20c838e761e1': `Valg av kutt`,
's7417792bbe720149': `Gjør om`,
's741fae02b3dd24f3': `Pixelert`,
's743f778233e42a3f': `Sett inn en sidebemerkning`,
's744d993d03f29851': `Skjerm`,
's748c0074eff45884': `Manipulering`,
's74aa0039a87141e2': `Ellipse`,
's74b9781bacfcc87c': `Punjabi`,
's74cd20a7aece9b91': `Fyll boksen`,
's75109f5307578a61': `Velkommen til WebWriter`,
's75a27f43413e02c5': `Fransk`,
's75d83fc3f0cfab40': `Overskrift`,
's762e5704cc84089d': `Angi andre stilalternativer for valgte elementer`,
's77318393dfdb0775': `Fjern rad`,
's77e594ddcc10c774': `Tillate kommersiell bruk?`,
's782eac2b3e80323d': `Merk valget som vektlagt`,
's782f286a79cca35d': `Relativ`,
's78673a3539cb1915': `Øverst til venstre`,
's78789724e789221c': `Størrelse`,
's789ff24c8f03f1a4': `Bokstavavstand`,
's7995733bf97c01cc': `Serbokroatisk`,
's7a99528e7b64635a': `occitansk`,
's7aaf0c06e69600f1': `Feil med `,
's7ae49e142487766c': `Tilgang til fellesskapet`,
's7af555180b30a947': `Åpne utviklerverktøyene`,
's7b4ba250601b8667': `Sett inn en mal`,
's7b560d8693ed8f42': `Oppreist`,
's7b9994904c4f5b54': `tadsjikisk`,
's7bdf0fd5b014d36c': `Sterk betydning`,
's7beb1e77e82363eb': `Angre den siste endringen i det aktive dokumentet`,
's7c61118554a0ec36': `Maksimum (x)`,
's7c95876637f6a9d7': `Filter`,
's7cb4e55c59663b1c': `Selskap`,
's7cfe12cd14df9950': `Logg av`,
's7d27db3c9639c6dd': `Alternativ`,
's7d8103f6f06f83d6': `Polstring`,
's7d864465dddbb50d': `Tillat endring av størrelse`,
's7de0e28d6c309a4e': `Tillat berøringshandlinger`,
's7dea785045c3cc74': `Trykk på ny tastekombinasjon...`,
's7e0b179d4d1414eb': `Skriv inn lenke`,
's7e6570f2f1ae320f': `Syntetisere skrifttyper`,
's7ecb1f29332293e5': `Grunnlinje for justering`,
's7ed13ccddb1bf3c3': `Overlegg`,
's7edbe0b213199995': `Bachelorgrad`,
's7ede1c55e35ce9d6': `Simulering`,
's7f09197a4814079b': `Angi interaktivitetsalternativer for valgte elementer`,
's7f326a142e856656': `Stil`,
's7fcb35d23be1e643': `Feltsett`,
's80570196a9ce6d11': `Aktiver telemetri`,
's806f84eb0ace116e': `Se hva du har valgt, og endre det. Kopier, klipp ut, lim inn, fest eller gjør layoutendringer. Tilbyr ulike alternativer avhengig av hva du har valgt, f.eks. formatering av tekst.`,
's80a42b81c52d4d8f': `Caret-farge`,
's80b71fc6f43c5ce1': `Løs`,
's812cbda653daaeba': `Denne funksjonen er ikke implementert ennå`,
's814d528c8af55807': `Definisjon listeelement`,
's81c3d8809658b951': `Kashmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Fortsett`,
's8247d32213e35f24': `Sett inn en hoved`,
's82665b2ffabc9c0a': `Nettsted`,
's828b1ecea8715884': `Pan (til venstre)`,
's833bd0422a7ef95d': `Tabulatorstørrelse`,
's83420ad7b6a14db5': `Veksle mellom utviklingsverktøy`,
's83c15613b6f6f3c8': `Kun på nett`,
's83cd32b685ccc9b7': `Kontroller`,
's83f26d02dd7aa681': `Synlig`,
's840fa49e8989c028': `Posisjon/form`,
's844a76d1843ceb3c': `Tilbakestill til standard`,
's84e4e8ae645b82ac': `Øverst til høyre (y)`,
's84e9c7f8785ca60b': `Sett inn et skjema`,
's8517ae4da104b004': `Tabell Kolonnegruppe`,
's85186a61e0d55bac': `Video`,
's851a7deea5984646': `Lisens som Creative Commons OER?`,
's85f9aa6d3ea0e421': `Tabellens bunntekstgruppe`,
's864b0e6270e97246': `Merk valget som en sidekommentar`,
's8670e5ad3bf0dcf8': `Lagre som`,
's8688d74dd3716d6e': `Tastaturgenveier for kommandoer`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Form margin`,
's87cefc710b3567fb': `Inneholder`,
's88676f992b2965db': `Strekk celleinnhold`,
's886897f2fd4edb99': `Skjult`,
's886c5db2a5579873': `Konsept`,
's888c71e8fcb916d3': `Automatisk lagring`,
's88a62d29529948fb': `Sett inn en tabell`,
's89950d86c8004d4b': `Hopp over ingen overlappinger`,
's89bca7498f20e041': `Bakgrunnsklipp`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Pause før`,
's8a4ff2bd9c13498c': `Rekord`,
's8a6585c48ea104e9': `Skjul tomme celler`,
's8a9eb438abac7c6a': `Etiketter`,
's8b0432eecbd8b034': `Oppdatering`,
's8b7580c35e2aef87': `Øverst til venstre (y)`,
's8bc4affa761aa8a2': `Sett inn et bilde`,
's8c7f51cb067644c7': `Dataliste`,
's8d342ecaa9e75b9b': `Forholdet`,
's8d797888455f4147': `Pauserom`,
's8d83386457e91813': `Angre/gjenopprett endringene dine eller forhåndsvis fra elevens perspektiv.`,
's8d8643013a7754d1': `Juster tekst`,
's8df30fe2a50d3479': `Sett inn en mulighet for linjeskift`,
's8e715248c3a78446': `Klipp ut utvalget`,
's8f29e48d6b9a1aa8': `Sett inn en tabelloverskriftsrad`,
's8f4be9f086eb530f': `Angre`,
's8f533296a536965e': `Lagre som...`,
's8fad58c831ecf017': `Ruby tekstbeholder`,
's8ffe7abcbed8eb43': `Vertikal, fra venstre mot høyre`,
's90105521fcc40453': `Med WebWriter Cloud-kontoer kan du lagre dokumenter på nettet og dele dem med
          studentene dine. Legg til en konto her, og den vil være tilgjengelig som et sted for
          lagring, lasting, deling og åpning av dokumenter.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Skriftpalett`,
's90f7c1cf501ea0a7': `Color dodge`,
's91093e0b087911ba': `Vektleggingsposisjon`,
's919e1724f589c9b1': `Spor`,
's91c5ed7769d00b65': `Sett inn embed`,
's9219acd5bef6269e': `Under venstre`,
's92548405912d46bf': `Skroll snapjustering (y)`,
's9258280591309342': `Skroll snapjustering (x)`,
's927d796559f49439': `Bakgrunn Opprinnelse`,
's92b177e579ef7b97': `Utheving`,
's92f846b9be2e8e8d': `Marker valget som kursiv`,
's93566b84230af4f5': `Sett inn et bilde`,
's936aa0b239679585': `Sett inn et tematisk brudd (vises vanligvis som en horisontal linje)`,
's9370dc6afa716b57': `Grense`,
's93f083e654a45715': `Bretonsk`,
's94653c76b2d86a04': `Definert begrep`,
's9485af2e7cd9418f': `Grunnskole`,
's94d2eee44b292567': `Veksle mellom avanserte alternativer`,
's94d61907ee22a8c1': `Koreansk`,
's94eb1effbbb6498b': `Overløp`,
's951aa3a6439f1271': `Liste markør`,
's9565553d163fc92a': `Manus`,
's957787fc6b7ea5c0': `Pan (opp)`,
's95c161f68e5180a5': `Inspiser utvalget`,
's95d56e58f816d211': `Nederlandsk`,
's95d8e41a64635c7c': `Hvit plass`,
's95de7e1eff6c053e': `Horisontal, fra topp til bunn`,
's960d3a90ac199368': `rumensk-retoromansk`,
's96532132a29dd542': `Sett inn lyd`,
's96a045dcade75ad0': `Tett kolonne`,
's9781a5bb3fcb26a3': `Velg et selskap først`,
's978522fbc9577a7e': `Somalisk`,
's97881699a2b21d5b': `Radgap`,
's97aa76056a81bd36': `Beregninger`,
's986facb3ecc9602c': `Sideveis, fra høyre mot venstre`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Ekstern fil`,
's98977a87d1b93941': `Tilbakestill informasjon, stiler og skript`,
's990d0e0fa2ab00b5': `Galisisk`,
's99229574e5692f19': `Grønlandsk`,
's99a990f3841ad283': `Filer av `,
's99b38e000175cc84': `Gjennomstreket`,
's99f110d27e30b289': `Tittel`,
's9ab10fbf4c7a7322': `Understreket posisjon`,
's9abadcc828884d7b': `Tekstområde`,
's9b7cd8860c8fc922': str`
          ${0}
          vil bli overskrevet. Er du sikker? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Bakgrunnsfarge`,
's9c8df9626d152d5a': `Definisjon liste begrep`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Tabellkolonne`,
's9cf68f87b8e6122f': `Aserbajdsjansk`,
's9d167ef77aed79b6': `Lag`,
's9d2d00982edafabb': `Tyrkisk`,
's9d430adc5be110e9': `Rekke bakover`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Sletting`,
's9df571714a1efb44': `En automatisk lagret versjon av denne utforskbare er tilgjengelig. Vil du laste den inn?`,
's9e28faa598332e2b': `Sett inn video`,
's9e3dbb678150edd4': `Angi skriftfamilie`,
's9e40e59654c8ad67': `Spalte`,
's9e85800d3700e31c': `Spor`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Skrifttypevariant`,
's9f1ecdb3061d9cbc': `Bevare områder`,
's9faf26107ed49fb9': `Sett inn en tabellcelle`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Overgang`,
's9ff3121d30f88d52': `Normal`,
's9ffe1bbe64712bf1': `Lerret`,
'sa00df4e39c72d3b4': str`
          ${0} støttes ikke 
        `,
'sa013e119fec906fb': `Rekke`,
'sa01e7bf33563ef72': `Bakgrunn Vedlegg`,
'sa126cf8c627cec1e': `Rendering av bilder`,
'sa13f72278add7513': `Under høyre`,
'sa1647e3b36ec08d7': `Kombiner oppreist`,
'sa172190ea21f9b1c': `Åpne innstillingene, åpne en utforskbar eller opprett en ny.`,
'sa1c6c459b9b5115c': `Absolutt`,
'sa2cba871f6cdd99f': `assamesisk`,
'sa2eff4dad1c119f1': `Rutenettmal`,
'sa30c12014e955946': `Russisk`,
'sa30f1981fd1cd441': `Skriftstørrelse`,
'sa311a24c1471a974': `Dokument`,
'sa352d168b262aa06': `Sett inn en bunntekst`,
'sa37fee6a52d18063': `Slett dokument`,
'sa39c7ac1d37f3bce': `Merk valget som et "toveis isolat`,
'sa3b4c01623211544': `Kraft`,
'sa40fd43756fa8913': `Persisk`,
'sa417644bef21a9aa': `Ikke navngitt tema`,
'sa43800e28be1bdbc': `Dekorasjonsfarge`,
'sa477cb1825dceb3b': `sudanesisk`,
'sa492a51a707930fa': `Sett inn et blokksitat`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Bildetekst nederst`,
'sa50d3c35533f1d99': `Alle felt`,
'sa53c5cb03a8fda50': `Fest markeringen som et utdrag i paletten`,
'sa557ae6bee9148a6': `Fremgang`,
'sa589e1df65dde0ec': `Angi størrelse, utfylling og marginer for de valgte elementene`,
'sa5c371b4bb75e590': `Venstre`,
'sa5c80e623459ffe4': `Sett inn en topptekst`,
'sa5df1bcdba46c3fb': `Figur Bildetekst`,
'sa602e3fd3f2d98fd': `Animasjon`,
'sa644d580d8a11e60': `Ruby-tilpasning`,
'sa645d315510dc09e': `Velg sti fra disken`,
'sa65d4ad99f1d8c06': `Angi tekstbakgrunn`,
'sa6607436f60ccc1a': `Estisk`,
'sa6f8d27bca557059': `Flytt meta/link/style-elementer opp/ned i dette elementet`,
'sa757645ad842da97': `Bevar pauser`,
'sa75b95980cd80e78': `Redaktør`,
'sa7698b3d20a6d1ec': `Rull`,
'sa778acc33947c7b8': `Avslutt turen`,
'sa78a67272a4a6f95': `Matematisk formel`,
'sa79167651dce1e80': `Alternativ tekst`,
'sa7af797a46c7d09a': `Tabellens bunntekst`,
'sa7dbe35b758c138d': `Sett inn et lerret`,
'sa7dc6b8ef3f595dc': `Sett inn en kilde`,
'sa8279f8211b3950d': `Bevar pauser og mellomrom`,
'sa8b55cab62e439b5': `Fjern kolonne`,
'sa8bbe0197d31b423': `Kort beskrivelse`,
'sa9ff3b762365abe6': `Transformer opprinnelse (z)`,
'saa02e3762368ff35': `Transformer opprinnelse (y)`,
'saa065776236bfa28': `Transformer opprinnelse (x)`,
'saa33768e03c45fc8': `Filstørrelse`,
'saaad98061a20ac39': `Sett inn en matematisk formel`,
'saab875d8cfcfe712': `Tema`,
'saad4380b9cc6cefd': `Alternativ over`,
'saaec15c97a9e4245': `Kolonne Revers`,
'sab0c57df694a0a09': `Trim start`,
'sab4d9283896d9422': `Snap-oppløsning piksler`,
'sab55faae8e165407': `Utfylling&lt;br&gt; som gap`,
'sab5e7d2a069a2951': `Yrkesfaglig sertifikat.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Juster til høyre`,
'sac895c732f350ac5': `Mørk`,
'saced41ddda8b2354': `Flex basis`,
'sad190f86451081c0': `Nepali`,
'sad6be321164d08c8': `Kompakt matematikk`,
'sadd352cc7f6f2307': `Bortsett fra`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Svensk`,
'sae1c7f13b7c0c47f': `Start`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Sett inn en beskrivelsesliste (ordliste, termliste)`,
'saf3da7c95cb17260': `Merk markeringen som et overstrekksmerke`,
'saf440a0a592f2835': `Oppdatering til`,
'saf9e5134ba1a7d30': `Scroll snap`,
'safc6f203342d09e2': `Veksler forhåndsvisningen for det aktive dokumentet`,
'sb0a7e3adf4a125ee': `Øverst til høyre`,
'sb0a974028c99ca6d': `Tillate tilpasninger?`,
'sb0d4f0f7993cf085': `Angi skriftstørrelse`,
'sb0f3327210fe18fc': `Spalter`,
'sb0f93c1c60c0249a': `Rubinbase`,
'sb1494c08c8c720d1': `Angi tekstfarge`,
'sb19611adbc88f711': `Avansert: Vis kommandoer for kilderedigering, f.eks. for å vise dokumentets HTML eller for å legge til egendefinerte stiler og skript.`,
'sb206d700d26b14ff': `Understreke`,
'sb233557012dcb328': `Flytt ned`,
'sb26035b596566abf': `Ikke navngitt`,
'sb2cda80610c8d6ea': `Plass til alle`,
'sb2dc787b0983ebc6': `litauisk`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Sentrum`,
'sb3ba3276ae93627c': `Sett inn en forhåndsformatert tekstblokk`,
'sb430f5b4824de0d3': `Velg en layout`,
'sb43db07b24da018a': `amharisk`,
'sb45f9fb4dba6e71a': `Uinnstilt`,
'sb4e003a459464d85': `kurdisk`,
'sb4f0310e6787d098': `usbekisk`,
'sb4f1dffbb6be6302': `Klar`,
'sb51270e19988f9bd': `Region`,
'sb59d621e3c93cc27': `Delte cellegrenser`,
'sb5e9e1776242b028': `Interaksjoner`,
'sb60bc1250aad44c1': `Spennvidde`,
'sb60dd9d23d31ee66': `Doktorgrad`,
'sb6103872073d369e': `Sett inn detaljer`,
'sb616811735bfbafd': `Tabellcelle`,
'sb628960829e223bb': `Hopp over alle overlappinger`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Søk og importer`,
'sb66e2181a7b5738a': `Ved å aktivere telemetri tillater du innsamling og oppbevaring av data i henhold til våre`,
'sb67e0e7c0869f982': `Forskjell`,
'sb68e83cda6c85af8': `Tabelloverskrift`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Dekorasjonstykkelse`,
'sb70c17f7899f9b01': `Latin`,
'sb71941f552f3504d': `Angi spesiell verdi`,
'sb740eab4afd5a710': `Automatisk flyt i nettet`,
'sb741b6e0ca589122': `Tilbakefør lag`,
'sb7c77d0415de05cf': `Kjør tester`,
'sb7fb7568f6883ab8': `Del det aktive dokumentet`,
'sb85774dc5d18ff0f': `Bekreft`,
'sb85b1e36579852a6': `Ugyldig e-post eller passord`,
'sb884fa76bfc55429': `Arabisk`,
'sb8a3d4df7d1c5e6b': `Balanse`,
'sb8f610a0e8df91fc': `Lysstyrke`,
'sb8f855b49234b81b': `Søk`,
'sb905da066c10182c': `Pluss mørkere`,
'sb940ade1bd81be7e': `Under venstre`,
'sb9e9a7dd45966756': `Marker valget som fet skrift`,
'sba509fd8ed61d1d5': `Ikke lagret fil`,
'sba64d8954d027206': `Ugjennomsiktighet`,
'sba88d90cd6c751b3': `Kolonneregel`,
'sbaf0a7c417e388af': `Helse`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Bakgrunnsfilter`,
'sbb85a407d730e13d': `Sett inn et søk`,
'sbb86c6c96f598bb8': `Blandet`,
'sbba0156f795d8c07': `Rediger valg`,
'sbba865d4b437944f': `Attributt`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Avinstaller`,
'sbc5f2a81604baf9b': `Rubrikken 6`,
'sbc5f2b81604bb14e': `Overskrift 5`,
'sbc5f2c81604bb301': `Rubrikken 4`,
'sbc5f2d81604bb4b4': `Rubrikken 3`,
'sbc5f2e81604bb667': `Overskrift 2`,
'sbc6953a36ced943f': `personvernerklæring`,
'sbd181cd54b8402a4': `Rediger utvalget`,
'sbd35ee879d9cf770': `Ruby-tekst`,
'sbd40f40cbadd38d5': `Fjern denne widgetpakken`,
'sbd72dc858de95ce8': `Burmesisk`,
'sbe3c60c65f129daa': `Humaniora`,
'sbe4a7c8f231739b3': `eller lim inn/slipp/plukk fil`,
'sbe90de083557ef3e': `Swahili`,
'sbefb6064cba01844': `Sett inn et linjeskift`,
'sbf00e1ee999ea94e': `Sett inn et skript`,
'sbf519920c2017d67': `Hengende`,
'sbfa01f189a68d3e9': `Flex vokse`,
'sbff54e740c4086eb': `Vis ukjente pakker`,
'sbfff51feacf30196': `Sanskrit`,
'sc0ceaa9843510f67': `turkmenere`,
'sc1611c0558728a2a': `Stilling`,
'sc1a155cc25899250': `Tabellradgruppe`,
'sc1aa1f6051b7102a': `rumensk`,
'sc1edebeaef92b7bd': `Fast tabelloppsett`,
'sc1fff4f356dfb2fb': `Forvandle`,
'sc24bda3c061fddf8': `Klikkbart område`,
'sc252a4e091763606': `Sett inn en bunntekst i tabellen`,
'sc2536e077514accc': `Rulling`,
'sc275dd00036d16cb': `Sitater karakter`,
'sc28864200d2a3799': `Kopier QR-koden som bilde`,
'sc2a24a9dd41a9503': `Dekorasjonslinje`,
'sc2b734cca2fa643b': `Panorering (ned)`,
'sc2e2a0dbf03723b7': `Avansert: Vis pakker fra ukjente kilder i pakkebehandleren (Advarsel: Kan være utrygt)`,
'sc3998b77d72c2932': `Sett inn et nettsted (som en innebygd ramme)`,
'sc3ac225273c8316b': `Generelt`,
'sc3cfee84dbbf36ae': `Lokal fil`,
'sc3f09a9b6fa4fbed': `På innsiden`,
'sc43767deea72e9f3': `Beskrivelse Liste`,
'sc462bbdd36bcba6b': `Referanseboks`,
'sc4ee3e4ee994dafd': `Ukrainsk`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Perspektivets opprinnelse (y)`,
'sc52e8b794c0913d6': `Perspektivets opprinnelse (x)`,
'sc53de149fcaad713': `Mellom karakterene`,
'sc546f489f9c0cced': `Veksler testmodus for det aktive dokumentet`,
'sc5bcf50d1b578d9f': `Innstillinger for skriftfunksjon`,
'sc5cb39478b9b7625': `Merk markeringen som et abonnement`,
'sc6415b50ff928294': `Listeelement`,
'sc650ff15b20fe9d3': `Roter (z)`,
'sc6578b15b2154365': `Roter (x)`,
'sc65aff15b2183e58': `Roter (y)`,
'sc6da0f4a7e4d710e': `Overstyring av skriftspråk`,
'sc74e3567875ce255': `Både taggen til widgeten din og navnet på NPM-pakken din`,
'sc7eb080b96e244df': `Malay`,
'sc8ac7ef92b95df3f': `Flytt (x)`,
'sc8af536e2084ade0': `Palett`,
'sc8b022f92b992bc2': `Flytt (y)`,
'sc8b39af92b9c2d81': `Flytt (z)`,
'sc8d2c7f6c33a2b32': `Angi tekststil (justering, innrykk, avstand osv.) for valgte elementer`,
'sc8fa0e3de389ef1c': `Justere skriftstørrelse`,
'sc9474bf7a0668d73': `Sammendrag`,
'sc94e314312a8900c': `Tsjekkisk`,
'sc980855a000b76ea': `Bunn`,
'sc98b103772de63f4': `Finsk`,
'sca7cfe2bef51b2a5': `Rot`,
'sca7fed2bef53cb99': `Rolle`,
'scabe6ecee5e01fd2': `Maltesisk`,
'scace301a88231cce': `Embed`,
'scbc55f622ec078c1': `Vis boks`,
'scbe537fc38ff4c13': `Automatiske kolonner i rutenettet`,
'scc1db59d292cbc4c': `Seksjon`,
'scc56b218a2689c42': `armensk`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Polstringsboks`,
'scd9cedeb5ece3adb': `Bindestrek`,
'scdf536b65be39ec5': ` Opprett/importer`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideografisk`,
'sceecdd0bb404bc17': `Sett inn en opsjonsgruppe`,
'scf00d48fd5953a03': `Gresk`,
'scf932840a69dbb7c': `Portugisisk`,
'scf932a8577057752': `Bunntekst`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Nederst til høyre`,
'sd01178c54f648118': `Balansekolonner`,
'sd03bff50f87f82d4': `Tegn med bindestrek`,
'sd05a155fe09c2866': `Online når du bruker`,
'sd0864ea6cb6ef22e': `Fellesskapet`,
'sd10fdbe6caf9a998': `Linjeskift`,
'sd121d3b959b7888d': `Optimaliser hastigheten`,
'sd1a78e667a1a139f': `Merk markeringen som en innsetting`,
'sd1cffad290ea5b3b': `Behold alle`,
'sd1f10284eeb17b25': `Fiji`,
'sd1f44f1a8bc20e67': `E-post`,
'sd1f81984eeb7c0e8': `Fyll`,
'sd29dc07235eea0f5': `Sitat`,
'sd2addf69477cd4b4': `Importer pakke`,
'sd2ed26defc646d47': `Bakgrunnsfilter`,
'sd2ef82b8ea877c6d': `afrikaans`,
'sd319aae1401f1e19': `Fast`,
'sd3a288c1094b8a63': `Kolonnens regelbredde`,
'sd3c65ef5c380c046': `Innfelt`,
'sd3dcb76f7b28adb8': `latvisk`,
'sd3eca1e0f4209f6e': `Trim alle`,
'sd3f402df8619ddcd': `Denne informasjonen om deg legges automatisk til i nye dokumenter. Du kan endre
          dette for hvert dokument i metadataredigeringsprogrammet.`,
'sd4368b12645d3c0f': `Sett inn en portal`,
'sd452cebf4a0313d1': `Vis kommandoer for kilderedigering`,
'sd48cc52117f4d68b': `Italiensk`,
'sd52660ee947ca58b': `Sett inn en tabellkolonne`,
'sd588d17a1b25c220': `Tekstoverløp`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Høyere utdanning.`,
'sd5cf95145e4d89ca': `Fjern festet til dette utdraget`,
'sd5fd9d11a92f5b1d': `Nederst til venstre (y)`,
'sd60c9bbc51375635': `Sett inn en knapp`,
'sd66c4767fa3dde28': `Accentfarge`,
'sd679c8b1bf8cc8a5': `Små caps`,
'sd7086c4425c53c80': `Skriftfamilie`,
'sd837f42ac7cbfb58': `Form (utvendig)`,
'sd88076d2994ee0fb': `Utelukkelse`,
'sd89a2e529b31ef43': `Gå tilbake`,
'sd8a345e95668b73b': `Vertikal, fra høyre mot venstre`,
'sd8ce9e57270b030d': `Fontstrekk`,
'sd8ecf227c7c49331': `Matematisk`,
'sd8f923198e0c5c6a': `Slutt`,
'sd9c21e5f60d6bdd8': `Dansk`,
'sd9ff8e2612e63d50': `Størrelse på kantboks`,
'sda2d76b976502a8d': `Åpne...`,
'sda344aacb837387e': `Plassering i container`,
'sda5b6fa8b771f996': `Flyter til venstre`,
'sda9254d1f1228e1a': `Ungarsk`,
'sdb1595f5c742dfbb': `Inndata`,
'sdb711380a28fec75': `Sett inn en liste (sortert)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Nederst til høyre (y)`,
'sdc48456f9a27ae02': `Generator`,
'sdc70d81cf6c28533': `georgisk`,
'sdd1ff479d04ac140': `Offentlig`,
'sdd2fc8919a9c3111': `Blandingsmodus for bakgrunn`,
'sdd35b688281b6dea': `Japansk`,
'sddc49047f66a64ab': `Ingen beskrivelse gitt`,
'sdef34fe08bb28b09': `Kinesisk (forenklet)`,
'sdf62e305e1594805': `Merk utvalget med en rubin-annotasjon`,
'sdf946172dfa0328f': `Overskrift`,
'sdf9bc5d9b7f3e3de': `Justering`,
'se036b53f145441cd': `Blandet innhold`,
'se06f459fccdc3ce9': `Justere siste tekstlinje`,
'se0a782a8be8e018b': `Norsk`,
'se0cda6b80a1bb50f': `slovakisk`,
'se0f67eae944f8f94': `Mute`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Artikkel`,
'se1f5bb0386c88f96': `Angir fargen på den valgte teksten`,
'se219da7b1e955c65': `Tydelig formatering`,
'se25e4f2cb77b8be8': `Språk for WebWriter-grensesnittet og nye dokumenter`,
'se2796c5824ec8916': `Synlighet av innhold`,
'se308836a594808b6': `singalesisk`,
'se36c5b1baf5e0660': `Hvor som helst`,
'se39c065efa467782': `baskisk`,
'se3b4c857f91f80d7': `Snarveier på tastaturet`,
'se47baf2fd16b9d2b': `Mal`,
'se48bd9e6c2a3109d': `Regnskap`,
'se58467472725ad0c': `Bildeoppløsning`,
'se58f06c2b0583ff7': `Velg koordinater`,
'se5dc1e97fb743ade': `Avstand`,
'se619a501d1bfe6a5': `Pakk inn`,
'se62385ac082368d2': `Merk utvalget som kilde for sitat`,
'se6297163cac9d276': `Rediger kilde`,
'se633223a0b88625e': `Celleplassering`,
'se638417c560cfe5c': `Bryt inn`,
'se64f418b4e733b6c': `Sett inn en utgang`,
'se6cdad455e2d8c02': `Sett inn en divisjon`,
'se79c0a3ac70d8fb3': `Asp. forhold (x)`,
'se79fae3ac710dc36': `Asp. forhold (y)`,
'se7fad370d8fb4cec': `Optimaliser lesbarheten`,
'se8a94b4effa2033e': `Alfabetisk`,
'se95d4e55ea186d9a': `Farge på rullefeltet`,
'se96d43a515b8451c': `Slovensk`,
'se96fd76ba1b2975a': `Sentralt`,
'se9ac05f36b004eb0': `Skjul introduksjonsturen. Deaktiver slik at omvisningen vises igjen.`,
'se9b1fec72ffd8f48': `Lokalt`,
'sea24bdcaa2bd2dec': `Obligatorisk snap`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Veksler mellom metadataredigeringsprogrammet`,
'sea896ed51ad33287': `Ingen spesifikke stiler tilgjengelig`,
'seaaaeb09e3b4e78b': `Redigeringskommandoer`,
'seabae79729c4b2ad': `Bytt e-post`,
'seaecc8267bad6234': `Ungdomsskolen`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Unngå kolonne`,
'seb4e52ef5ec7a7dc': `Farger/effekter`,
'seb8982ae8c3cdcc5': `Indonesisk`,
'sebbced89e0db2894': `Første baseline`,
'sec02109a0dd2a6c8': `Uthevet farge`,
'sec2557a35b702525': `Variabel`,
'sec2da4aa7a02b925': `Islandsk`,
'sec30fbb20f102670': `Sett inn sammendrag`,
'sec8b0b6c729816b6': `Overskrift Gruppe`,
'seccd05955adb76bc': `Plakat`,
'sed17285cd25d6389': `Katalog hvor package.json er plassert`,
'sed318ec045c5144f': `Over`,
'sed713f1b916fb469': `Rammeavstand (x)`,
'sed74a31b9172942c': `Kantavstand (y)`,
'sed86bd0deb2e5372': `Transformer tekst`,
'see2fcaedf9743ec6': `Beliggenhet`,
'seec6798afe90ffc8': `Skriv ut`,
'sef00c258bc1ecf1e': `Denne utforskbare har endringer som ikke er lagret.`,
'sef23dd271edd4a8b': `Nederst til venstre`,
'sef24caccbd4645ef': `Fleksibel krymping`,
'sef49aec68fd1dc66': `Navn`,
'sef73fe18e351eb35': `Nøkkelord`,
'sef75f458d77491af': `Opsjonsgruppe`,
'sefcf950b3cc4fc3b': `Språk`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Innhold`,
'sf0cab2483f66aa2e': `Tilpasset`,
'sf0e261e04eda82ff': `Utseende`,
'sf1045382c1fd9a85': `Eksakte trykkfarger`,
'sf14c35392ec7bf10': `Denne funksjonen er ikke tilgjengelig i Firefox. Den er tilgjengelig i Chrome eller Edge.`,
'sf14f9d5f9f6ca342': `Pluss lettere`,
'sf1868dc19e3917bb': `Spansk`,
'sf190149f9d8bbb2a': `Skrivemodus`,
'sf1e79171c4856543': `Er du sikker? Denne handlingen kan ikke reverseres, og alle innstillingene dine vil
          bli slettet og tilbakestilt.`,
'sf21c1f60c7515f44': `Merk utvalget som prøveutdata`,
'sf21fb4f4b9e8911f': `Bredde`,
'sf22a3737146ec910': `WebWriter kan bygge inn SVG direkte i dokumentet.`,
'sf2514d5dc78b1654': `Sett inn widget`,
'sf28903d4ca0ddcfc': `Fjern denne kontoen`,
'sf2ab37af0abc55ef': `Skjul intro-tur`,
'sf2bdb0b4d7b9c039': `Bengali`,
'sf2cbb5e519264e67': `Endre størrelse både horisontalt og vertikalt`,
'sf2d5cbc2fe0ad65a': `Klissete`,
'sf2d96d0eb32cb81f': `Animasjonskomposisjon`,
'sf2de3dbe2108637a': `Rendering av form`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Sett inn et spor`,
'sf3c4da68b08a2590': `Madagaskisk`,
'sf471ec2496f904cc': `Kasser endringer`,
'sf4849bc200e279ed': `Bildetekst til tabellen`,
'sf486ca1fdbe08645': `Sett inn en figur`,
'sf4b537d4cbd8f5fd': `Tekst øverst`,
'sf4e0e02a5277ef23': `Sett inn et tekstområde`,
'sf4f067d41efd4b83': `Skala (y)`,
'sf4f3cbd41f002b46': `Skala (x)`,
'sf4fa67d41f05a008': `Skala (z)`,
'sf5197db2d5f2926a': `Roter`,
'sf52d840949a980d1': str`
          ${0}
          vil bli slettet permanent. Er du sikker? 
        `,
'sf55d634dcc743595': `Tjenester`,
'sf59c9081d106dd9c': `Merk valget som en variabel`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Slett et dokument`,
'sf65df67a03bebe4b': `Påkrevd for denne widgeten`,
'sf6673729c03ae999': `Tilbakestill WebWriter`,
'sf67571992e7dc88e': `Hele perioden`,
'sf6b4934598f7ed10': `Tillat valg`,
'sf6e1665c7022a1f8': `Passord`,
'sf79e0d78b56444f1': `Inline-ende`,
'sf7a5f7a7c80c3082': `Begge`,
'sf7c0eba7c822e3d6': `Fet`,
'sf86bd4d2982f3b74': `Merk valget som kode`,
'sf8e82313fa411494': `Merk valget som en lenke`,
'sf955eff73fb6b573': `Serbisk`,
'sf9929e2d356260c5': `Multipliser`,
'sf993bb199fefbe04': `Alle`,
'sf9ecf969dd4b8164': `Begge kantene`,
'sf9f2c719a04066ec': `App`,
'sfa49a5bb1a5d353e': `Privat tilgang`,
'sfa59c7777e2a0eeb': `Sett inn en dataliste`,
'sfaa0a67db5c11f72': `Innrykk i første tekstlinje`,
'sfb231a52211b133f': `Ingen ombryting av tekst`,
'sfb68cae41d749423': `Innledende`,
'sfb9b6edb0ed378c9': `Sitat Kilde`,
'sfbbab09dbe553571': `Sett inn en vektortegning (SVG)`,
'sfc00292e778b67e2': `Meter`,
'sfc63e31ac7c956ed': `Velg`,
'sfc815c9078bba30a': `Last ned QR-kode som bilde`,
'sfcdd8e672c75b713': `Adresse`,
'sfcebd18506f1e535': `Flyt`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Produksjon`,
'sfdb1e4d90981a535': `Del dette dokumentet`,
'sfdeef3dccf409f81': `Dette nøkkelordet er påkrevd for widgets`,
'sfe6e758ad2603c1d': `Mastergrad`,
'sfee1c12daf838935': `Fargeforbrenning`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Sett inn en dialogboks`,
'sffa395f64ec6ac36': `Bulgarsk`,
'sffdadf0a576fd802': `Høyde`,
'spaceKey': `Plass`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Opp`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  